import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import UserUpdate from 'components/User/Update';

const ScreenUserUpdate = props => {
  const { match, classes } = props;
  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8} lg={8} xl={6}>
          <UserUpdate id={match.params.id} />
        </GridItem>
      </GridContainer>
    </div>
  );
};

ScreenUserUpdate.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenUserUpdate);
